export const APP_TITLE = 'Attendix'
